/*
 * @ Author: wangjiyu
 * @Date: 2019-12-19 09:52:52
 * @LastEditTime : 2021-08-19 16:02:58
 * @LastEditors  : 蔡传明
 * @Description: file content
 */
import HttpClient from '@chehejia/club-lib/lib/httpUtils/HttpClient';
import Constants from '../../enum/Constants';

export default class QuestionService {
    // 发布问题(v1接口)
    public static publish(param) {
        return HttpClient.post(
            Constants.getQuestion(),
            '/pa/questions',
            param
        ).then((data) => {
            return data;
        });
    }
    // 发布相关接口(v2接口)
    public static publish_v2(param) {
        return HttpClient.post(
            Constants.getQuestion_v2(),
            '/pa/publish',
            param
        ).then((data) => {
            return data;
        });
    }
    // 编辑相关接口(v2接口)
    public static editorial_v2(param) {
        return HttpClient.post(
            Constants.getQuestion_v2(),
            '/pa/eidtorial',
            param
        ).then((data) => {
            return data;
        });
    }
    // 获取内容详情
    public static getDetail(id) {
        const config: any = {};
        const defaultParam: any = {
            editorial: false,
        };
        config.params = Object.assign({}, defaultParam);
        return HttpClient.get(
            Constants.getQuestion_ver2(),
            `/product/pa/${id}`,
            config
        ).then((data) => {
            return data;
        });
    }
    // 获取搜索问题列表
    public static searchList(param) {
        const config: any = {};
        const defaultParam: any = {
            pageNo: 1,
            pageSize: 10,
        };
        config.params = Object.assign(defaultParam, param);
        return HttpClient.get(
            Constants.getQuestion(),
            '/pa/web/questions',
            config
        ).then((data) => {
            return data;
        });
    }
    // 获取问答我的列表（我的回答，我的发布）
    public static myQuestionList(param) {
        const config: any = {};
        const defaultParam: any = {
            pageNo: 1,
            pageSize: 10,
        };
        config.params = Object.assign(defaultParam, param);
        return HttpClient.get(
            Constants.getQuestion(),
            '/product/pa/answer',
            config
        ).then((data) => {
            return data;
        });
    }

    // 判断回答是否可用，true为可用
    public static checkAnser(questionProductId) {
        const config: any = {};
        const defaultParam: any = {
            questionProductId,
        };
        config.params = Object.assign({}, defaultParam);
        return HttpClient.get(
            Constants.getQuestion(),
            '/pa/answer-check',
            config
        ).then((data) => {
            return data;
        });
    }
}
